import { z } from 'zod';

// Cursor pagination (design §6.12). Lists are newest first; `nextCursor` is opaque
// and null on the last page.

/** The query every paginated list accepts. */
export const PageQuery = z.object({
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type PageQuery = z.infer<typeof PageQuery>;

/** A page of `item`. */
export function paginated<T extends z.ZodType>(item: T) {
  return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}

export interface Paginated<T> {
  items: T[];
  nextCursor: string | null;
}
